module.exports = "resources-list"